// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 86 ? "d25fa4da" : chunkId) + "." + {"86":"7422dc6d2cfea750","422":"d09c4cacb4d700e1"}[chunkId] + ".js";
};